import IztButton from './src/izt-button'

IztButton.install = Vue => {
  Vue.component(IztButton.name, IztButton)
}

export default IztButton